import React, { useEffect, useState } from "react"
import { Box, Button, Checkbox, FormControlLabel, TextField, Typography, FormControl } from "@mui/material"
import Grid from "@mui/material/Grid2"
import DownloadIcon from "@mui/icons-material/Download"
import CustomTable from "../../components/table/Table"
import { useDispatch, useSelector } from "react-redux"
import { createRole, deleteRole, fetchRoles, updateRole } from "../../redux/Slice/roleSlice"
import { setLoading } from "../../redux/Slice/loaderSlice"
import { side_menus } from "../../constants/SideMenus";
import { fetchEmployees, fetchInactiveEmployees, updateEmployee } from "../../redux/Slice/employeeSlice";
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import { Link } from "react-router-dom"

const columns = [
  { id: 'sno', label: 'S.No', minWidth: 50, align:'start' },
  { id: 'user_id', label: 'IDs', minWidth: 150, align:'start' },
  { id: 'name', label: 'Role Name', minWidth: 150, align:'start' },
  { id: 'email', label: 'Email', minWidth: 150, align:'start' },
  { id: 'role', label: 'Role', minWidth: 150, align:'start' },
  { id: 'action', label: 'Action', minWidth: 100, align:'center', actionType: [{view: true}] },
];

const InactiveEmployee = () => { 

  const dispatch = useDispatch();

  const { profile } = useSelector((state) => state.auth);

  const getModule = profile?.permissions?.find(va => va.moduleName === "Employee Management" || va.moduleName === "*")?.actions;

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [searchQuery, setSearchQuery] = useState("");

  const [buttonVal, setButtonVal] = useState("Submit");

  const initialState = {
    "name": "",
    "status": true,
    "permissions": []
  }

  const [formData, setFormdata] = useState(initialState);

  console.log(getModule);

  const { employees,totalCount } = useSelector((state)=> state.employee);

  const modifiedRows = employees ? employees?.map((va, index)=> ({sno:(index+1+((page-1)*rowsPerPage)), ...va, role: va?.role?.name})) : [] ;

  const handleSearch = () => {
    console.log("Search query:", searchQuery)
  }

  const handleExport = () => {
    console.log("Exporting data...")
  }

  const handleReset = () => {
    setFormdata(initialState);
    setButtonVal("Submit");
  }

  const handleEdit = (val) =>{
    setFormdata(val);
    setButtonVal("Update");
  }

  const handleStatus = (val) => {
    const r_id = val._id;
    const formData = {
      status : !val.status
    }
    dispatch(updateEmployee({r_id, formData}))
    .then(()=>{
      dispatch(setLoading(false));
      handleReset();
    })
    .catch((error)=>{
      dispatch(setLoading(false));
    })
  }
  

  const handleDelete = (val) => {
    dispatch(setLoading(true))
    dispatch(deleteRole(val))
    .then(()=>{
      dispatch(setLoading(false));
    })
    .catch((error)=>{
      dispatch(setLoading(false));
    })
  }

  useEffect(()=>{
    const params = {
      page: page,
      limit: rowsPerPage,
      searchTerm: searchQuery 

    }
    if(getModule?.includes("employee_inactive") || getModule?.includes("*")){
    // dispatch(setLoading(true))
    dispatch(fetchInactiveEmployees(params))
    // .then(() => {
    //     dispatch(setLoading(false))
    //         })
    // .catch((error) => {
    //     dispatch(setLoading(false))
    //   })
    }
  }, [dispatch, getModule, page, rowsPerPage,searchQuery])

  return (
    <div className="content">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h5" sx={{ mb: 3, mt: 3 }}>
          Inactive Employees<Typography component="span">({totalCount})</Typography>
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
            {(getModule?.includes("employee_inactive") || getModule?.includes("*")) &&
                    <>
          <TextField size="small" placeholder="Search by Employee Name" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} fullWidth />
          <Button variant="contained" onClick={handleSearch}>
            search
          </Button>
          </>
                  }
        </Box>
      </Box>
      {(getModule?.includes("employee_inactive") || getModule?.includes("*")) &&
      <CustomTable columns={columns} rows={ employees ? modifiedRows : [] } page={page} setPage={setPage} rowsPerPage={rowsPerPage} setRowsPerPage={setRowsPerPage} totalCount={totalCount} />
      }
    </div>
  )
}

export default InactiveEmployee
